import React from 'react';
import About from '../About/About';
import Blogs from '../Blogs/Blogs';
import ContactMe from '../ContactMe/ContactMe';
import MainHeader from '../MainHeader/MainHeader';
import Project from '../Project/Project';
import Services from '../Service/Service';
import WorkSummary from '../WorkSummary/WorkSummary';

const Home = () => {
    return (
        <div>
            <MainHeader></MainHeader>
            <About></About>
            <WorkSummary></WorkSummary>
            <Project></Project>
            <Blogs></Blogs>
            <Services></Services>
            <ContactMe></ContactMe>
        </div>
    );
};

export default Home;